import { AttributeTypes, UserProfileTypes, AttributePropertyTypes, AttributeRules, AttributeIcons } from '../enum';

export const getAllAttributeTypes = () => {
    return [
        { name: 'Heading', value: AttributeTypes.HEADING },
        { name: 'Sub Heading', value: AttributeTypes.SUB_HEADING },
        { name: 'Free Text', value: AttributeTypes.STATIC_TEXT },
        { name: 'Input Text', value: AttributeTypes.INPUT_TEXT },
        { name: 'Number', value: AttributeTypes.NUMBER },
        { name: 'Long Text', value: AttributeTypes.LONG_INPUT_TEXT },
        { name: 'Date', value: AttributeTypes.DATE },
        { name: 'Dropdown', value: AttributeTypes.DROP_DOWN },
        { name: 'Multi Select', value: AttributeTypes.MULTI_DROP_DOWN },
        { name: 'Radiobutton', value: AttributeTypes.RADIO },
        { name: 'Checkbox', value: AttributeTypes.CHECKBOX },
        { name: 'Duration', value: AttributeTypes.DURATION },
    ];
};

export const getDefaultTypes = () => {
    return [
        { name: 'Active Only', value: true },
        { name: 'Inactive Only', value: false },
    ];
};
export const getUserProfileTypes = () => {
    return [
        { name: 'Normal', value: UserProfileTypes.NORMAL },
        { name: 'User Profile', value: UserProfileTypes.USER_PROFILE },
        { name: 'Both', value: UserProfileTypes.BOTH },
    ];
};

export const getAttributePropertyTypes = () => {
    return [
        { name: 'Normal Attribute', code: AttributePropertyTypes.NORMAL },
        { name: 'Tagged Attribute', code: AttributePropertyTypes.TAGGED },
    ];
};

export const getAttributeValidationRules = () => {
    return [
        { name: 'Minimum Value', code: AttributeRules.MINIMUM_VALUE, checked: null },
        { name: 'Maximum Value', code: AttributeRules.MAXIMUM_VALUE, checked: null },
        { name: 'Minimum Length', code: AttributeRules.MINIMUM_LENGTH, checked: null },
        { name: 'Maximum Length', code: AttributeRules.MAXIMUM_LENGTH, checked: null },
    ];
};

export const getAttributeIcons = () => {
    let iconArr = [];
    for (var i = 1; i <= 120; i++) {
        iconArr.push({ id: i, value: AttributeIcons['ICON_' + i], name: 'Icon ' + i });
    }
    return iconArr;
};
